import { IconButton } from '@mui/material';
import { DesktopDatePicker, DesktopDateTimePicker, DesktopTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { useMemo } from 'react';
import IconCalendarEvent from '~icons/bx/calendar-event';
import { theme } from '@arc/frontend/ui-theme';
const styles = {
  input: ({
    disabled,
    readOnly,
    archived,
    error
  }) => ({
    width: '100%',
    '& .MuiInputBase-root': {
      color: disabled ? theme.colors.text.disabled : theme.colors.text.primary,
      fontStyle: 'normal',
      backgroundColor: disabled && !readOnly ? theme.colors.input.disabledBackground : archived ? theme.colors.background.paperTransparent : readOnly ? theme.colors.background.fullTransparent : 'white'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '2px',
      border: readOnly ? 'none' : `1px solid ${error ? theme.colors.palettes.error.main : disabled ? theme.colors.input.disabledBorder : theme.colors.input.border} !important`
    },
    '& .MuiInputBase-input': {
      minWidth: 0,
      padding: '0.5435rem 0 0.5435rem 0.75rem',
      WebkitTextFillColor: 'unset !important'
    },
    '& .MuiInputAdornment-root': {
      marginLeft: 0
    }
  }),
  calendar: {
    '& .MuiDayCalendar-weekDayLabel, & .MuiPickersDay-root': {
      fontSize: '0.85rem'
    },
    '& .MuiMultiSectionDigitalClockSection-root:after': {
      // Don't allow scrolling past the end of the hours, minutes, or AM/PM lists
      display: 'none'
    }
  }
};
export const dateTimeStyles = styles;
export function SelectorDateTime(props) {
  const {
    // Selector props
    error,
    disabled = false,
    readOnly = false,
    testid,
    inputRef,
    // DesktopDateTimePickerProps
    value,
    onChange,
    onAccept,
    onError,
    // SelectorDateTimeProps
    archived,
    clearable,
    type = 'datetime',
    disabledPlaceholderDate,
    actionBar,
    actionBarProps,
    ...validationProps
  } = props;
  const Component = useMemo(() => {
    switch (type) {
      case 'date':
        {
          return DesktopDatePicker;
        }
      case 'time':
        {
          return DesktopTimePicker;
        }
      case 'datetime':
        {
          return DesktopDateTimePicker;
        }
    }
  }, [type]);
  return <LocalizationProvider dateAdapter={AdapterLuxon}>
			<Component disabled={disabled} readOnly={readOnly} inputRef={inputRef} value={value ?? (disabledPlaceholderDate && disabled ? disabledPlaceholderDate : null)} onChange={onChange} onAccept={onAccept} onError={onError} {...validationProps} slots={{
      openPickerButton: CalendarEventIconButton,
      // @ts-expect-error - Getting these types right is hard
      actionBar
    }} slotProps={{
      actionBar: actionBarProps,
      field: {
        clearable,
        inputProps: {
          // @ts-expect-error - MUI doesn't have a testid prop
          'data-testid': testid ? `${testid}-input` : undefined
        }
      },
      openPickerButton: {
        disabled,
        readOnly
      },
      desktopPaper: {
        sx: styles.calendar
      }
    }} sx={styles.input({
      disabled,
      readOnly,
      archived,
      error
    })} />
		</LocalizationProvider>;
}
function CalendarEventIconButton({
  disabled,
  readOnly,
  ...props
}) {
  if (readOnly) {
    return null;
  }
  return <IconButton {...props} disabled={disabled}>
			<IconCalendarEvent style={{
      width: '1em',
      height: '1em',
      color: disabled ? theme.colors.text.faint : theme.colors.input.adornment
    }} />
		</IconButton>;
}